.OuterContainer {
  display: flex;
  flex-flow: column nowrap;
  height: 100vh;
  height: 100svh;
  overflow: hidden;

  & > header {
    flex-basis: auto;
  }

  & > div {
    flex-basis: auto;
    flex-grow: 1;
    overflow-y: scroll;

    & main {
      min-height: 75vh;
      padding: 0.5rem 0.5rem;
      @media (min-width: 768px) {
        padding: 1rem 1rem;
      }
    }
  }
}

.Footer {
  background-color: white;
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
  max-width: 1536px;
  margin: 0 auto;
  padding: 0.5rem 0.5rem;
  @media (min-width: 768px) {
    padding: 1rem 1rem;
  }
}
